import {
  getDefTempSettingLogoBg,
  getDomainInformation,
  getSmsSingName, getSysName,
  saveDefTempSettingLogoBg,
  saveDomainInformation,
  setSmsSingName,
  setSysName
} from '../services/personalization';
import { message } from 'antd';
import {PATHS, RES_STATUS} from '../utils/constants';

export default {
  namespace: 'personalization',
  state: {
    domainDefuserPwd: '',
    domainBgImage: '',
    domainI18nLogoZH: '',
    domainI18nLogoEN: '',
    domainEmailTitleLogo: '',
    domainBgImageFileList: [],
    domainI18nLogoZHFileList: [],
    domainI18nLogoENFileList: [],
    domainEmailTitleLogoFileList: [],
    tempBg: '',
    tempLogo: '',
    tempLogoEN: '',
    tempBgFileList: [],
    tempLogoFileList: [],
    tempLogoENFileList: [],
    smsSingName: '',
    sysNameZH:'',
    sysNameEN:''
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *getSmsSingName(_, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale) || 'zh_CN';
      const { data: sp, status, msg } = yield call(getSmsSingName, { locale });
      if (status !== RES_STATUS.success) {
        message.error(msg);
        return;
      }
      yield put({
        type: 'update',
        payload: {
          smsSingName: sp
        }
      });
    },
    *setSmsSingName({ smsSingName }, { call, put, select }) {
      const i18n = yield select(state => state.i18n);
      const locale = i18n.locale || 'zh_CN';
      const { status, msg } = yield call(setSmsSingName, {
        locale,
        paramValue: smsSingName
      });
      if (status !== RES_STATUS.success) {
        message.error(msg);
        yield put({ type: 'getSmsSingName' });
      } else {
        message.success(i18n.messages.per_b_5);
      }
    },
    * getSysName(_, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale) || 'zh_CN';
      const { data, status, msg } = yield call(getSysName, { locale });
      if (status !== RES_STATUS.success) {
        message.error(msg);
        return;
      }
      yield put({
        type: 'update', payload: {
          sysNameEN: data.sysNameEN,
          sysNameZH:data.sysNameZH
        }
      });
    },
    * setSysName({ sysNameEN, sysNameZH}, { call, put, select }) {
      const i18n = yield select(state => state.i18n);
      const locale = i18n.locale || 'zh_CN';
      const { status, msg } = yield call(setSysName, { locale, sysNameEN:sysNameEN,sysNameZH:sysNameZH });
      if (status !== RES_STATUS.success) {
        message.error(msg);
        yield put({ type: 'getSysName' });
      }else{
        message.success(i18n.messages.per_b_5);
      }

      yield put({
        type: 'menu/updateSysName', sysName: {
          sysNameEN: sysNameEN,
          sysNameZH: sysNameZH
        }
      });
    },
    *getDefTempSettingLogoBg(_, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale) || 'zh_CN';
      const { data: ts, status, msg } = yield call(getDefTempSettingLogoBg, {
        locale
      });
      if (status !== RES_STATUS.success) {
        message.error(msg);
        return;
      }
      yield put({
        type: 'update',
        payload: {
          tempBg: ts.tempBg,
          tempLogo: ts.tempLogo,
          tempLogoEN: ts.tempLogoEN,
          tempBgFileList: [],
          tempLogoFileList: [],
          tempLogoENFileList: []
        }
      });
    },
    *saveDefTempSettingLogoBg({ defTempSettingLogoBg }, { call, put, select }) {
      const { type, url } = defTempSettingLogoBg;
      const locale = yield select(state => state.i18n.locale) || 'zh_CN';
      const { status, msg } = yield call(saveDefTempSettingLogoBg, {
        locale,
        type,
        url
      });
      if (status !== RES_STATUS.success) {
        message.error(msg);
        yield put({ type: 'getDefTempSettingLogoBg' });
      }
    },

    *getDomainInformation(_, { call, put, select }) {
      let { domainName: domain } = yield select(state => state.login.userInfo);
      domain = domain ? domain : sessionStorage.getItem('domainName');
      const locale = yield select(state => state.i18n.locale) || 'zh_CN';
      const { data: dmLogin, status, msg } = yield call(getDomainInformation, {
        locale,
        domain
      });
      if (status !== RES_STATUS.success) {
        message.error(msg);
        return;
      }
      yield put({
        type: 'menu/updateLogoBg',
        logoBg: {
          domainBgImage: dmLogin.bgImage,
          domainI18nLogoZH: dmLogin.i18nLogoZH,
          domainI18nLogoEN: dmLogin.i18nLogoEN
        }
      });
      yield put({
        type: 'menu/updateSysName', sysName: {
          sysNameEN: dmLogin.sysNameEN,
          sysNameZH: dmLogin.sysNameZH
        }
      });
      yield put({
        type: 'update',
        payload: {
          domainBgImage: dmLogin.bgImage,
          domainI18nLogoZH: dmLogin.i18nLogoZH,
          domainI18nLogoEN: dmLogin.i18nLogoEN,
          domainEmailTitleLogo: dmLogin.emailTitleLogo,
          domainBgImageFileList: [],
          domainI18nLogoZHFileList: [],
          domainI18nLogoENFileList: [],
          domainEmailTitleLogoFileList: [],
          sysNameZH:dmLogin.sysNameZH,
          sysNameEN:dmLogin.sysNameEN,
        }
      });
    },
    *saveDomainInformation({ domainInformation }, { call, put, select }) {
      const { type, value } = domainInformation;
      const { domainName: domain } = yield select(
        state => state.login.userInfo
      );
      const i18n = yield select(state => state.i18n);
      const locale = i18n.locale || 'zh_CN';
      const { status, msg } = yield call(saveDomainInformation, {
        locale,
        domain,
        type,
        value
      });
      if (status !== RES_STATUS.success) {
        message.error(msg);
        yield put({ type: 'getDomainInformation' });
      } else {
        switch (type) {
          case 'domainDefuserPwd':
            message.success(i18n.messages.per_b_5);
            yield put({
              type: 'update', payload: {
                domainDefuserPwd : ''
              }
            });
            break;
        }
      }
    }
  },

  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.personalization) {
          dispatch({ type: 'getDefTempSettingLogoBg' });
          dispatch({ type: 'getSmsSingName' });
        }
        dispatch({ type: 'getDomainInformation' });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/personalization.js